var _style, _g, _g2, _g3, _path, _g4, _path2, _path3, _path4, _line, _ellipse, _path5, _path6, _g5, _g6, _rect, _rect2, _rect3, _rect4, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomApPevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.45;fill:#222B45;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:#1761B0;}\r\n\t.st4{opacity:0.35;fill:url(#SVGID_3_);}\r\n\t.st5{fill:#AF0C15;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:url(#SVGID_4_);}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:1.3806;stroke-miterlimit:10;}\r\n\t.st9{opacity:0.45;fill:url(#SVGID_5_);}\r\n\t.st10{fill:url(#SVGID_6_);}\r\n\t.st11{opacity:0.45;}\r\n\t.st12{fill:url(#SVGID_7_);}\r\n\t.st13{fill:url(#SVGID_8_);}\r\n\t.st14{fill:url(#SVGID_9_);}\r\n\t.st15{opacity:0.45;fill:#FFFFFF;}\r\n\t.st16{fill:url(#SVGID_10_);}\r\n\t.st17{fill:url(#SVGID_11_);}\r\n\t.st18{fill:none;stroke:#FFFFFF;stroke-width:1.2389;stroke-miterlimit:10;}\r\n\t.st19{opacity:0.45;fill:url(#SVGID_12_);}\r\n\t.st20{fill:url(#SVGID_13_);}\r\n\t.st21{fill:url(#SVGID_14_);}\r\n\t.st22{opacity:0.35;fill:#222B45;}\r\n\t.st23{opacity:0.75;}\r\n\t.st24{fill:#222B45;}\r\n\t.st25{opacity:0.75;fill:#222B45;}\r\n\t.st26{fill:url(#SVGID_15_);}\r\n\t.st27{fill:url(#SVGID_16_);}\r\n\t.st28{fill:url(#SVGID_17_);}\r\n\t.st29{fill:none;stroke:url(#SVGID_18_);stroke-width:1.812;stroke-miterlimit:10;}\r\n\t.st30{fill:url(#SVGID_19_);}\r\n\t.st31{fill:url(#SVGID_20_);}\r\n\t.st32{fill:url(#SVGID_21_);}\r\n\t.st33{fill:url(#SVGID_22_);}\r\n\t.st34{fill:url(#SVGID_23_);}\r\n\t.st35{fill:url(#SVGID_24_);}\r\n\t.st36{fill:url(#SVGID_25_);}\r\n\t.st37{fill:url(#SVGID_26_);}\r\n\t.st38{fill:url(#SVGID_27_);}\r\n\t.st39{fill:none;stroke:url(#SVGID_28_);stroke-width:1.812;stroke-miterlimit:10;}\r\n\t.st40{fill:url(#SVGID_29_);}\r\n\t.st41{fill:url(#SVGID_30_);}\r\n\t.st42{fill:url(#SVGID_31_);}\r\n\t.st43{fill:url(#SVGID_32_);}\r\n\t.st44{fill:url(#SVGID_33_);}\r\n\t.st45{fill:url(#SVGID_34_);}\r\n\t.st46{fill:url(#SVGID_35_);}\r\n\t.st47{fill:url(#SVGID_36_);}\r\n\t.st48{fill:url(#SVGID_37_);}\r\n\t.st49{fill:url(#SVGID_38_);}\r\n\t.st50{fill:url(#SVGID_39_);}\r\n\t.st51{opacity:0.6;}\r\n\t.st52{opacity:0.5;}\r\n\t.st53{fill:url(#SVGID_40_);}\r\n\t.st54{fill:url(#SVGID_41_);}\r\n\t.st55{fill:url(#SVGID_42_);}\r\n\t.st56{fill:url(#SVGID_43_);}\r\n\t.st57{fill:url(#SVGID_44_);}\r\n\t.st58{fill:url(#SVGID_45_);}\r\n\t.st59{fill:url(#SVGID_46_);}\r\n\t.st60{fill:url(#SVGID_47_);}\r\n\t.st61{fill:url(#SVGID_48_);}\r\n\t.st62{fill:url(#SVGID_49_);}\r\n\t.st63{fill:url(#SVGID_50_);}\r\n\t.st64{fill:url(#SVGID_51_);}\r\n\t.st65{fill:url(#SVGID_52_);}\r\n\t.st66{fill:url(#SVGID_53_);}\r\n\t.st67{fill:url(#SVGID_54_);}\r\n\t.st68{fill:url(#SVGID_55_);}\r\n\t.st69{clip-path:url(#SVGID_57_);fill:url(#SVGID_58_);}\r\n\t.st70{opacity:0.57;clip-path:url(#SVGID_57_);}\r\n\t.st71{fill:url(#SVGID_59_);}\r\n\t.st72{fill:url(#SVGID_60_);}\r\n\t.st73{fill:url(#SVGID_61_);}\r\n\t.st74{fill:url(#SVGID_62_);}\r\n\t.st75{fill:url(#SVGID_63_);}\r\n\t.st76{fill:url(#SVGID_64_);}\r\n\t.st77{fill:url(#SVGID_65_);}\r\n\t.st78{fill:url(#SVGID_66_);}\r\n\t.st79{fill:url(#SVGID_67_);}\r\n\t.st80{fill:url(#SVGID_68_);}\r\n\t.st81{fill:url(#SVGID_69_);}\r\n\t.st82{fill:url(#SVGID_70_);}\r\n\t.st83{fill:url(#SVGID_71_);}\r\n\t.st84{fill:url(#SVGID_72_);}\r\n\t.st85{fill:url(#SVGID_73_);}\r\n\t.st86{fill:url(#SVGID_74_);}\r\n\t.st87{fill:url(#SVGID_75_);}\r\n\t.st88{fill:url(#SVGID_76_);}\r\n\t.st89{fill:url(#SVGID_77_);}\r\n\t.st90{fill:url(#SVGID_78_);}\r\n\t.st91{fill:url(#SVGID_79_);}\r\n\t.st92{fill:url(#SVGID_80_);}\r\n\t.st93{fill:#DBDCE0;}\r\n\t.st94{fill:url(#SVGID_81_);}\r\n\t.st95{fill:url(#SVGID_82_);}\r\n\t.st96{fill:url(#SVGID_83_);}\r\n\t.st97{fill:#939396;}\r\n\t.st98{fill:#00D0FF;}\r\n\t.st99{fill:url(#SVGID_84_);}\r\n\t.st100{fill:url(#SVGID_85_);}\r\n\t.st101{fill:url(#SVGID_86_);}\r\n\t.st102{fill:url(#SVGID_87_);}\r\n\t.st103{fill:url(#SVGID_88_);}\r\n\t.st104{fill:url(#SVGID_89_);}\r\n\t.st105{fill:url(#SVGID_90_);}\r\n\t.st106{fill:url(#SVGID_91_);}\r\n\t.st107{fill:url(#SVGID_92_);}\r\n\t.st108{fill:url(#SVGID_93_);}\r\n\t.st109{fill:url(#SVGID_94_);}\r\n\t.st110{fill:url(#SVGID_95_);}\r\n\t.st111{fill:url(#SVGID_96_);}\r\n\t.st112{fill:url(#SVGID_97_);}\r\n\t.st113{fill:url(#SVGID_98_);}\r\n\t.st114{fill:url(#SVGID_99_);}\r\n\t.st115{fill:url(#SVGID_100_);}\r\n\t.st116{fill:url(#SVGID_101_);}\r\n\t.st117{fill:none;stroke:#B3B3B3;stroke-width:0.4184;stroke-miterlimit:10;}\r\n\t.st118{fill:url(#SVGID_102_);}\r\n\t.st119{opacity:0.34;fill:none;stroke:#282D41;stroke-width:0.4105;stroke-miterlimit:10;}\r\n\t.st120{fill:#B3B3B3;}\r\n\t.st121{fill:url(#SVGID_103_);}\r\n\t.st122{fill:url(#SVGID_104_);}\r\n\t.st123{fill:url(#SVGID_105_);}\r\n\t.st124{fill:url(#SVGID_106_);}\r\n\t.st125{fill:url(#SVGID_107_);}\r\n\t.st126{fill:url(#SVGID_108_);}\r\n\t.st127{fill:url(#SVGID_109_);}\r\n\t.st128{fill:url(#SVGID_110_);}\r\n\t.st129{fill:url(#SVGID_111_);}\r\n\t.st130{fill:url(#SVGID_112_);}\r\n\t.st131{fill:url(#SVGID_113_);}\r\n\t.st132{fill:url(#SVGID_114_);}\r\n\t.st133{fill:url(#SVGID_115_);}\r\n\t.st134{fill:url(#SVGID_116_);}\r\n\t.st135{fill:url(#SVGID_117_);}\r\n\t.st136{fill:url(#SVGID_118_);}\r\n\t.st137{fill:url(#SVGID_119_);}\r\n\t.st138{fill:#78A4EB;}\r\n\t.st139{fill:none;stroke:#78A4EB;stroke-width:0.5558;stroke-miterlimit:10;}\r\n\t.st140{fill:#171717;}\r\n\t.st141{fill:#444444;}\r\n\t.st142{fill:#0C3580;}\r\n\t.st143{fill:none;stroke:#92E8C2;stroke-width:1.197;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st144{fill:none;stroke:#8DCBFC;stroke-width:1.197;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st145{fill:#395188;}\r\n\t.st146{fill:#92E8C2;}\r\n\t.st147{fill:none;stroke:#111111;stroke-width:1.2551;stroke-miterlimit:10;}\r\n\t.st148{opacity:0.05;fill:#FFFFFF;}\r\n\t.st149{opacity:0.15;fill:#FFFFFF;}\r\n\t.st150{opacity:0.5;fill:#FFFFFF;}\r\n\t.st151{fill:url(#SVGID_120_);}\r\n\t.st152{fill:url(#SVGID_121_);}\r\n\t.st153{fill:none;stroke:#FFFFFF;stroke-width:0.8074;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st154{fill:none;stroke:#333333;stroke-width:1.1556;stroke-miterlimit:10;}\r\n\t.st155{fill:#606060;}\r\n\t.st156{fill:url(#SVGID_122_);}\r\n\t.st157{fill:url(#SVGID_123_);}\r\n\t.st158{fill:url(#SVGID_124_);}\r\n\t.st159{fill:url(#SVGID_125_);}\r\n\t.st160{fill:url(#SVGID_126_);}\r\n\t.st161{fill:url(#SVGID_127_);}\r\n\t.st162{fill:none;stroke:#282D41;stroke-width:0.5558;stroke-miterlimit:10;}\r\n\t.st163{fill:none;stroke:#FFFFFF;stroke-width:0.7109;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st164{fill:#455C9A;}\r\n\t.st165{fill:#DA8F48;}\r\n\t.st166{fill:none;stroke:#DD6309;stroke-width:1.1544;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st167{fill:none;stroke:#FFFFFF;stroke-width:1.3043;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st168{fill:#8D78B2;}\r\n\t.st169{fill:none;stroke:#374FA6;stroke-width:0.8264;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st170{fill:none;stroke:#FFFFFF;stroke-width:0.5558;stroke-miterlimit:10;}\r\n\t.st171{fill:#1E0032;}\r\n\t.st172{fill:none;stroke:#AE6FFA;stroke-width:1.6717;stroke-miterlimit:10;stroke-dasharray:3.3435,3.3435;}\r\n\t.st173{fill:#C1C7D6;}\r\n\t.st174{fill:#DDE4F0;}\r\n\t.st175{fill:#A5A9B7;}\r\n\t.st176{fill:#182246;}\r\n\t.st177{fill:#D25A2C;}\r\n\t.st178{fill:#69B884;}\r\n\t.st179{fill:#CB2376;}\r\n\t.st180{fill:#66A8DE;}\r\n\t.st181{fill:#3359D0;}\r\n\t.st182{fill:#E4E9FB;}\r\n\t.st183{fill:#BFC9E8;}\r\n\t.st184{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;stroke-dasharray:3.3435,3.3435;}\r\n\t.st185{fill:#78C9DD;}\r\n\t.st186{fill:#E7AD47;}\r\n\t.st187{fill:#263A81;}\r\n\t.st188{fill:#233471;}\r\n\t.st189{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;}\r\n\t.st190{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;stroke-dasharray:3.3006,3.3006;}\r\n\t.st191{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;stroke-dasharray:3.2024,3.2024;}\r\n\t.st192{fill:#C4373B;}\r\n\t.st193{fill:#EABD68;}\r\n\t.st194{fill:#157224;}\r\n\t.st195{fill:#E58F36;}\r\n\t.st196{fill:none;stroke:#AE6FFA;stroke-width:1.545;stroke-miterlimit:10;stroke-dasharray:3.09,3.09;}\r\n\t.st197{fill:url(#SVGID_128_);}\r\n\t.st198{fill:url(#SVGID_129_);}\r\n\t.st199{fill:none;stroke:#92E8C2;stroke-width:1.1063;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st200{fill:none;stroke:#8DCBFC;stroke-width:1.1063;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st201{fill:none;stroke:#FFFFFF;stroke-width:0.657;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st202{fill:none;stroke:#DD6309;stroke-width:1.0669;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st203{fill:none;stroke:#FFFFFF;stroke-width:1.2054;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st204{fill:none;stroke:#374FA6;stroke-width:0.7638;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st205{fill:none;stroke:#282D41;stroke-width:0.5137;stroke-miterlimit:10;}\r\n\t.st206{fill:none;stroke:#FFFFFF;stroke-width:0.5137;stroke-miterlimit:10;}\r\n\t.st207{fill:#D1EBF8;}\r\n\t.st208{opacity:0.5;fill:#E0D7E8;}\r\n\t.st209{opacity:0.58;fill:url(#SVGID_130_);}\r\n\t.st210{opacity:0.58;fill:url(#SVGID_131_);}\r\n\t.st211{opacity:0.58;fill:url(#SVGID_132_);}\r\n\t.st212{fill:#E7E4FC;}\r\n\t.st213{fill:#BFD0FC;}\r\n\t.st214{fill:url(#SVGID_133_);}\r\n\t.st215{fill:#F1F1F1;}\r\n\t.st216{fill:#777777;}\r\n\t.st217{fill:#E9EDFD;}\r\n\t.st218{fill:#333333;}\r\n\t.st219{fill:#69B9EF;}\r\n\t.st220{fill-rule:evenodd;clip-rule:evenodd;fill:#69B9EF;}\r\n\t.st221{fill-rule:evenodd;clip-rule:evenodd;fill:#E9B34D;}\r\n\t.st222{fill:#497DB3;}\r\n\t.st223{fill:#D05433;}\r\n\t.st224{fill:#A52B31;}\r\n\t.st225{fill:#F7EC41;}\r\n\t.st226{fill:#90D677;}\r\n\t.st227{fill:#E9A42B;}\r\n\t.st228{fill:#5752B6;}\r\n\t.st229{fill:#625DB5;}\r\n\t.st230{fill:#E1E5FD;}\r\n\t.st231{fill:#353389;}\r\n\t.st232{fill:#C4E6F1;}\r\n\t.st233{fill:#B92F14;}\r\n\t.st234{fill:#D7D5F7;}\r\n\t.st235{opacity:0.28;}\r\n\t.st236{fill:#221B22;}\r\n\t.st237{fill:#564C54;}\r\n\t.st238{fill:#EDE0C3;}\r\n\t.st239{fill:#F77659;}\r\n\t.st240{fill:#E33D15;}\r\n\t.st241{fill:#F0F0F0;}\r\n\t.st242{fill:#EBB12B;}\r\n\t.st243{fill:#D38400;}\r\n\t.st244{fill:#3639D9;}\r\n\t.st245{fill:#4B71F8;}\r\n\t.st246{fill:url(#SVGID_134_);}\r\n\t.st247{fill:url(#SVGID_135_);}\r\n\t.st248{fill:url(#SVGID_136_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -109.7525 263.1242)",
    className: "st138",
    cx: 262.74,
    cy: 264.05,
    rx: 177.48,
    ry: 177.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -109.7525 263.1242)",
    className: "st139",
    cx: 262.74,
    cy: 264.05,
    rx: 188.58,
    ry: 188.58
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M448.71,398.83H76.78V180.51c0-7.61,6.17-13.77,13.77-13.77h344.38c7.61,0,13.77,6.17,13.77,13.77 V398.83z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.78,
    y: 388.88,
    className: "st141",
    width: 371.93,
    height: 9.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M443.08,393.43H82.41v-211.3c0-5.53,4.48-10,10-10h340.66c5.53,0,10,4.48,10,10V393.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M114.04,393.43H82.41v-211.3c0-5.53,4.48-10,10-10h21.63V393.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M443.08,191.82H82.41v-9.69c0-5.53,4.48-10,10-10h340.66c5.53,0,10,4.48,10,10V191.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M444.28,412.5H81.21c-9.23,0-17.1-6.68-18.61-15.78l-0.17-1.03h400.62l-0.17,1.03 C461.38,405.83,453.51,412.5,444.28,412.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M458.92,395.7c-2.59,7.48-9.67,12.68-17.81,12.68H78.04c-5.11,0-9.8-2.06-13.23-5.43 c3.27,5.76,9.45,9.55,16.4,9.55h363.07c9.23,0,17.1-6.68,18.61-15.78l0.17-1.03H458.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 128.86,
    y1: 208.67,
    x2: 255.69,
    y2: 208.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 266.16,
    y1: 208.67,
    x2: 308.33,
    y2: 208.67
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 128.86,
    y1: 298.95,
    x2: 255.69,
    y2: 298.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 298.95,
    x2: 291.2,
    y2: 298.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 128.86,
    y1: 324.9,
    x2: 255.69,
    y2: 324.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 266.16,
    y1: 324.9,
    x2: 291.2,
    y2: 324.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 128.86,
    y1: 371.05,
    x2: 255.69,
    y2: 371.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 371.05,
    x2: 308.33,
    y2: 371.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 216.06,
    y1: 378.26,
    x2: 255.69,
    y2: 378.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 266.16,
    y1: 378.26,
    x2: 308.33,
    y2: 378.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 157.08,
    y1: 219.06,
    x2: 255.69,
    y2: 219.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 219.06,
    x2: 281.69,
    y2: 219.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 157.08,
    y1: 225.4,
    x2: 255.69,
    y2: 225.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 225.4,
    x2: 293.11,
    y2: 225.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 157.08,
    y1: 231.75,
    x2: 255.69,
    y2: 231.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 266.16,
    y1: 231.75,
    x2: 281.69,
    y2: 231.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 157.08,
    y1: 238.09,
    x2: 255.69,
    y2: 238.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 238.09,
    x2: 293.11,
    y2: 238.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 157.08,
    y1: 244.44,
    x2: 255.69,
    y2: 244.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 244.44,
    x2: 281.69,
    y2: 244.44
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 194.18,
    y1: 252.22,
    x2: 255.69,
    y2: 252.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 252.22,
    x2: 298.81,
    y2: 252.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 194.18,
    y1: 260.01,
    x2: 255.69,
    y2: 260.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 260.01,
    x2: 298.81,
    y2: 260.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 194.18,
    y1: 267.8,
    x2: 243.01,
    y2: 267.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 253.47,
    y1: 267.8,
    x2: 298.81,
    y2: 267.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 194.18,
    y1: 275.58,
    x2: 255.69,
    y2: 275.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 275.58,
    x2: 298.81,
    y2: 275.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 194.18,
    y1: 283.37,
    x2: 243.01,
    y2: 283.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 253.47,
    y1: 283.37,
    x2: 298.81,
    y2: 283.37
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 194.18,
    y1: 291.16,
    x2: 255.69,
    y2: 291.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 266.16,
    y1: 291.16,
    x2: 298.81,
    y2: 291.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 209.72,
    y1: 309.33,
    x2: 271.23,
    y2: 309.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 281.69,
    y1: 309.33,
    x2: 314.35,
    y2: 309.33
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 209.72,
    y1: 317.12,
    x2: 253.47,
    y2: 317.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 263.94,
    y1: 317.12,
    x2: 314.35,
    y2: 317.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 234.77,
    y1: 335,
    x2: 253.47,
    y2: 335
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 263.94,
    y1: 335,
    x2: 298.81,
    y2: 335
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 240.47,
    y1: 342.21,
    x2: 253.47,
    y2: 342.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 263.94,
    y1: 342.21,
    x2: 308.33,
    y2: 342.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 234.77,
    y1: 349.42,
    x2: 253.47,
    y2: 349.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st143",
    x1: 263.94,
    y1: 349.42,
    x2: 298.81,
    y2: 349.42
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 240.47,
    y1: 356.63,
    x2: 253.47,
    y2: 356.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "st144",
    x1: 263.94,
    y1: 356.63,
    x2: 308.33,
    y2: 356.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M103.88,208.67c0,3.12-2.53,5.66-5.66,5.66s-5.66-2.53-5.66-5.66c0-3.12,2.53-5.66,5.66-5.66 S103.88,205.55,103.88,208.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M101.83,181.98c0,1.44-1.17,2.62-2.62,2.62c-1.44,0-2.62-1.17-2.62-2.62c0-1.44,1.17-2.62,2.62-2.62 C100.66,179.36,101.83,180.53,101.83,181.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M111.43,181.98c0,1.44-1.17,2.62-2.62,2.62c-1.44,0-2.62-1.17-2.62-2.62c0-1.44,1.17-2.62,2.62-2.62 C110.26,179.36,111.43,180.53,111.43,181.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M121.02,181.98c0,1.44-1.17,2.62-2.62,2.62c-1.44,0-2.62-1.17-2.62-2.62c0-1.44,1.17-2.62,2.62-2.62 C119.85,179.36,121.02,180.53,121.02,181.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M103.88,231.06c0,3.12-2.53,5.66-5.66,5.66s-5.66-2.53-5.66-5.66s2.53-5.66,5.66-5.66 S103.88,227.94,103.88,231.06z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st145",
    cx: 98.22,
    cy: 253.45,
    r: 5.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M103.88,275.83c0,3.12-2.53,5.66-5.66,5.66s-5.66-2.53-5.66-5.66s2.53-5.66,5.66-5.66 S103.88,272.71,103.88,275.83z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M462.22,195.22h28.26c7.62,0,13.79,6.18,13.79,13.79v139.51c0,7.62-6.18,13.79-13.79,13.79h-42.72"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st148",
    cx: 406.23,
    cy: 196,
    r: 98.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st149",
    cx: 406.23,
    cy: 196,
    r: 90.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2076 -0.9782 0.9782 0.2076 130.1551 552.6798)",
    className: "st150",
    cx: 406.23,
    cy: 196,
    rx: 75.21,
    ry: 75.22
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.3857,
    y1: 192.7266,
    x2: 463.0545,
    y2: 192.7266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#3C3C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7808,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.53,299.4H353.91c-2.5,0-4.53-2.03-4.53-4.53V90.58c0-2.5,2.03-4.53,4.53-4.53h104.62 c2.5,0,4.53,2.03,4.53,4.53v204.29C463.05,297.37,461.03,299.4,458.53,299.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M455.48,295.66h-98.52c-2.38,0-4.32-1.93-4.32-4.32V94.11c0-2.38,1.93-4.32,4.32-4.32h98.52 c2.38,0,4.32,1.93,4.32,4.32v197.24C459.8,293.73,457.86,295.66,455.48,295.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.2753,
    y1: 90.4656,
    x2: 425.1649,
    y2: 90.4656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.94,92.37H389.5c-1.23,0-2.23-1-2.23-2.23v-1.58h37.89v1.58C425.16,91.37,424.17,92.37,422.94,92.37z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st153",
    x1: 398.38,
    y1: 89.79,
    x2: 414.06,
    y2: 89.79
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.238 -0.9713 0.9713 0.238 176.597 498.8477)",
    className: "st5",
    cx: 406.22,
    cy: 136.88,
    rx: 24.73,
    ry: 24.73
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M412.59,136.62H410c2.56-1.36,4.31-4.05,4.31-7.15c0-4.47-3.62-8.09-8.09-8.09c-4.47,0-8.09,3.62-8.09,8.09 c0,3.1,1.75,5.79,4.31,7.15h-2.59c-4.27,0-7.73,3.46-7.73,7.73v2.58c0,1.67,1.35,3.02,3.02,3.02h22.16 c1.67,0,3.02-1.35,3.02-3.02v-2.58C420.32,140.08,416.86,136.62,412.59,136.62z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M417.95,283.5h-23.47c-1.31,0-2.37-1.06-2.37-2.37l0,0c0-1.31,1.06-2.37,2.37-2.37h23.47 c1.31,0,2.37,1.06,2.37,2.37l0,0C420.32,282.44,419.26,283.5,417.95,283.5z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M434,233.96h-55.55c-5.02,0-9.08-4.07-9.08-9.08l0,0c0-5.02,4.07-9.08,9.08-9.08H434 c5.02,0,9.08,4.07,9.08,9.08l0,0C443.08,229.9,439.01,233.96,434,233.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M392.35,224.88c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5 S392.35,224.05,392.35,224.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M400.04,224.88c0,0.83-0.67,1.5-1.5,1.5c-0.83,0-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5 C399.37,223.38,400.04,224.05,400.04,224.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M407.73,224.88c0,0.83-0.67,1.5-1.5,1.5c-0.83,0-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5 C407.06,223.38,407.73,224.05,407.73,224.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M415.42,224.88c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5 S415.42,224.05,415.42,224.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M423.1,224.88c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5 S423.1,224.05,423.1,224.88z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M434,206.02h-55.55c-5.02,0-9.08-4.07-9.08-9.08l0,0c0-5.02,4.07-9.08,9.08-9.08H434 c5.02,0,9.08,4.07,9.08,9.08l0,0C443.08,201.96,439.01,206.02,434,206.02z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M429.06,197.88H383.4c-0.52,0-0.94-0.42-0.94-0.94c0-0.52,0.42-0.94,0.94-0.94h45.66 c0.52,0,0.94,0.42,0.94,0.94C430,197.46,429.58,197.88,429.06,197.88z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.7072,
    y1: 361.9154,
    x2: 483.6639,
    y2: 361.9154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8874
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 448.71,
    y: 358.86,
    style: {
      fill: "url(#SVGID_3_)"
    },
    width: 34.96,
    height: 6.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.7072,
    y1: 358.8637,
    x2: 470.7831,
    y2: 358.8637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8874
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 448.71,
    y: 357.99,
    className: "st7",
    width: 22.08,
    height: 1.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.7072,
    y1: 364.9672,
    x2: 470.7831,
    y2: 364.9672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8874
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 448.71,
    y: 364.1,
    style: {
      fill: "url(#SVGID_5_)"
    },
    width: 22.08,
    height: 1.74
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.0545,
    y1: 195.217,
    x2: 498.0112,
    y2: 195.217
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8874
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 463.05,
    y: 192.17,
    className: "st10",
    width: 34.96,
    height: 6.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.0545,
    y1: 192.1652,
    x2: 485.1303,
    y2: 192.1652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8874
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 463.05,
    y: 191.29,
    className: "st12",
    width: 22.08,
    height: 1.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.0545,
    y1: 198.2687,
    x2: 485.1303,
    y2: 198.2687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8874
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 463.05,
    y: 197.4,
    className: "st13",
    width: 22.08,
    height: 1.74
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M69.61,335.54v28.87c0,1.27-1.03,2.31-2.31,2.31H48.15"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 69.61,
    cy: 334.03,
    r: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 46.64,
    cy: 366.71,
    r: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 53.52,
    cy: 383.26,
    r: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 71.12,
    cy: 370.57,
    r: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M69.61,370.57H55.83c-1.27,0-2.31,1.03-2.31,2.31v9.07"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 101.2,
    cy: 144.49,
    r: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M169.61,144.49c0,0.83-0.68,1.51-1.51,1.51c-0.83,0-1.51-0.68-1.51-1.51c0-0.83,0.68-1.51,1.51-1.51 C168.93,142.98,169.61,143.66,169.61,144.49z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st162",
    x1: 166.59,
    y1: 144.49,
    x2: 102.6,
    y2: 144.49
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 376.28,
    cy: 79.38,
    r: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M386.33,79.38c0,0.83-0.68,1.51-1.51,1.51c-0.83,0-1.51-0.68-1.51-1.51c0-0.83,0.68-1.51,1.51-1.51 C385.66,77.87,386.33,78.55,386.33,79.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M343.6,117.86V84.72c0-2.95,2.39-5.34,5.34-5.34h25.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st162",
    x1: 386.33,
    y1: 79.38,
    x2: 409.56,
    y2: 79.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 347.88,
    cy: 401.89,
    r: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 445.33,
    cy: 401.89,
    r: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "st162",
    x1: 349.39,
    y1: 401.89,
    x2: 443.82,
    y2: 401.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M471.45,351.58c0,0.83-0.68,1.51-1.51,1.51c-0.83,0-1.51-0.68-1.51-1.51s0.68-1.51,1.51-1.51 C470.77,350.07,471.45,350.75,471.45,351.58z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 470.78,
    cy: 288.11,
    r: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st162",
    cx: 455.2,
    cy: 336.84,
    r: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M455.2,335.33v-16.39c0-0.72,0.58-1.3,1.3-1.3h12.99c0.72,0,1.3-0.58,1.3-1.3v-26.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M455.2,324.58h13.45c0.72,0,1.3,0.58,1.3,1.3v24.19"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9173 -0.3982 0.3982 0.9173 -113.583 55.4859)",
    className: "st6",
    cx: 76.78,
    cy: 301.17,
    rx: 19.7,
    ry: 19.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M93.76,286.5c3.4,3.93,5.46,9.06,5.46,14.67c0,12.39-10.05,22.44-22.44,22.44c-3.03,0-5.91-0.6-8.54-1.68 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M61.59,317.69c-4.46-4.1-7.25-9.99-7.25-16.52c0-12.39,10.05-22.44,22.44-22.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M79.36,291.99h1.62l-6.15,17.55h-1.62L79.36,291.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M89.89,300.36v1.6l-8.35,3.3v-1.55l6.63-2.55l-6.63-2.55v-1.55L89.89,300.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M63.67,301.96v-1.6l8.35-3.3v1.55l-6.63,2.55l6.63,2.55v1.55L63.67,301.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -28.4295 123.2752)",
    className: "st165",
    cx: 134.59,
    cy: 95.96,
    rx: 32,
    ry: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M162.17,72.13c5.52,6.39,8.87,14.72,8.87,23.83c0,20.13-16.32,36.44-36.44,36.44 c-4.91,0-9.6-0.97-13.88-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M109.93,122.79c-7.24-6.66-11.78-16.22-11.78-26.83c0-20.13,16.32-36.44,36.44-36.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M121.12,101.95l1.94-2.33c1,1.36,2.2,2.09,3.64,2.09c1.89,0,2.85-1.13,2.85-3.38v-9.47h-6.52v-2.85h9.92 v12.14c0,4.32-2.15,6.44-6.17,6.44C124.47,104.59,122.38,103.65,121.12,101.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M135.81,102.94l1.25-2.49c1.23,0.81,3.12,1.39,4.87,1.39c2.07,0,2.93-0.58,2.93-1.54 c0-2.67-8.64-0.16-8.64-5.73c0-2.64,2.38-4.37,6.15-4.37c1.86,0,3.98,0.45,5.23,1.2l-1.26,2.49c-1.33-0.79-2.67-1.05-4-1.05 c-1.99,0-2.93,0.65-2.93,1.57c0,2.83,8.64,0.31,8.64,5.78c0,2.62-2.41,4.32-6.33,4.32 C139.39,104.51,137.06,103.83,135.81,102.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 224.94,
    cy: 139.14,
    r: 36.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M256.09,112.22c6.24,7.22,10.02,16.63,10.02,26.92c0,22.74-18.43,41.17-41.17,41.17 c-5.55,0-10.84-1.1-15.68-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M197.07,169.46c-8.18-7.53-13.31-18.32-13.31-30.31c0-22.74,18.43-41.17,41.17-41.17"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M216.43,137.32c0,2.78-2.06,4.5-5.39,4.5h-2.86v3.65h-2.35v-12.65h5.21 C214.37,132.82,216.43,134.52,216.43,137.32z M214.06,137.32c0-1.59-1.07-2.51-3.13-2.51h-2.75v5.03h2.75 C213,139.83,214.06,138.91,214.06,137.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M230.03,132.82v12.65h-2.35v-5.42h-6.54v5.42h-2.35v-12.65h2.35v5.22h6.54v-5.22H230.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M244.03,137.32c0,2.78-2.06,4.5-5.39,4.5h-2.86v3.65h-2.35v-12.65h5.21 C241.97,132.82,244.03,134.52,244.03,137.32z M241.67,137.32c0-1.59-1.07-2.51-3.13-2.51h-2.75v5.03h2.75 C240.6,139.83,241.67,138.91,241.67,137.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st165",
    cx: 50.09,
    cy: 236.28,
    r: 37.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M82.14,208.58c6.42,7.43,10.31,17.11,10.31,27.7c0,23.4-18.97,42.36-42.36,42.36 c-5.71,0-11.16-1.13-16.13-3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M21.42,267.47C13,259.72,7.73,248.62,7.73,236.28c0-23.4,18.97-42.36,42.36-42.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.74,231.21v11.55h-2.15v-4.95h-5.97v4.95h-2.15v-11.55h2.15v4.77h5.97v-4.77H36.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M42.18,233.02h-3.83v-1.82h9.8v1.82h-3.83v9.74h-2.15V233.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.38,242.76l-0.02-7.66l-3.8,6.34h-0.96l-3.8-6.24v7.56h-2.05v-11.55h1.77l4.59,7.66l4.51-7.66h1.77 l0.02,11.55H60.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.52,231.21h2.15v9.74h6.04v1.82h-8.19V231.21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2374 -0.9714 0.9714 0.2374 -98.2068 148.6594)",
    className: "st3",
    cx: 45.58,
    cy: 136.88,
    rx: 22.91,
    ry: 22.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M65.32,119.82c3.95,4.57,6.35,10.54,6.35,17.06c0,14.41-11.68,26.09-26.09,26.09 c-3.52,0-6.87-0.7-9.93-1.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M27.92,156.08c-5.19-4.77-8.43-11.61-8.43-19.21c0-14.41,11.68-26.09,26.09-26.09"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.39,136.77c0-3.27,2.51-5.64,5.87-5.64c1.79,0,3.32,0.64,4.34,1.83l-1.32,1.24 c-0.8-0.86-1.79-1.28-2.93-1.28c-2.27,0-3.92,1.6-3.92,3.85c0,2.26,1.65,3.85,3.92,3.85c1.14,0,2.13-0.42,2.93-1.3l1.32,1.25 c-1.02,1.19-2.55,1.83-4.35,1.83C34.89,142.41,32.39,140.04,32.39,136.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.96,137.43h-2.35v2.32h-1.42v-2.32h-2.35v-1.33h2.35v-2.32h1.42v2.32h2.35V137.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M58.76,137.43h-2.35v2.32h-1.42v-2.32h-2.35v-1.33h2.35v-2.32h1.42v2.32h2.35V137.43z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 302.27,
    cy: 102.8,
    r: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M323.38,84.56c4.23,4.89,6.79,11.27,6.79,18.24c0,15.41-12.49,27.9-27.9,27.9 c-3.76,0-7.35-0.74-10.62-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M283.39,123.34c-5.55-5.1-9.02-12.42-9.02-20.54c0-15.41,12.49-27.9,27.9-27.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M287.57,102.68c0-3.23,2.47-5.56,5.79-5.56c1.76,0,3.27,0.63,4.28,1.81l-1.3,1.22 c-0.79-0.85-1.76-1.27-2.89-1.27c-2.24,0-3.86,1.58-3.86,3.8s1.62,3.8,3.86,3.8c1.13,0,2.1-0.42,2.89-1.28l1.3,1.24 c-1.01,1.17-2.52,1.81-4.3,1.81C290.04,108.25,287.57,105.91,287.57,102.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.61,106.95l0.7-1.56c0.86,0.7,2.24,1.19,3.57,1.19c1.68,0,2.4-0.6,2.4-1.41c0-2.33-6.43-0.8-6.43-4.82 c0-1.75,1.39-3.23,4.36-3.23c1.3,0,2.66,0.34,3.6,0.96l-0.63,1.56c-0.97-0.57-2.04-0.85-2.98-0.85c-1.67,0-2.35,0.65-2.35,1.47 c0,2.3,6.41,0.8,6.41,4.77c0,1.73-1.41,3.21-4.37,3.21C301.19,108.25,299.51,107.72,298.61,106.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M308.33,106.95l0.69-1.56c0.87,0.7,2.24,1.19,3.57,1.19c1.68,0,2.4-0.6,2.4-1.41 c0-2.33-6.43-0.8-6.43-4.82c0-1.75,1.39-3.23,4.36-3.23c1.3,0,2.66,0.34,3.6,0.96l-0.63,1.56c-0.97-0.57-2.04-0.85-2.98-0.85 c-1.67,0-2.35,0.65-2.35,1.47c0,2.3,6.41,0.8,6.41,4.77c0,1.73-1.41,3.21-4.37,3.21C310.91,108.25,309.23,107.72,308.33,106.95 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M258.48,67.14l-3.95,0.2l0.2-3.95c-1.52-1.02-3.25-1.75-5.11-2.11l-2.65,2.93l-2.65-2.93 c-1.86,0.36-3.59,1.09-5.11,2.11l0.2,3.95l-3.95-0.2c-1.02,1.52-1.75,3.25-2.11,5.11l2.93,2.65l-2.93,2.65 c0.36,1.86,1.09,3.59,2.11,5.11l3.95-0.2l-0.2,3.95c1.52,1.02,3.25,1.75,5.11,2.11l2.65-2.93l2.65,2.93 c1.86-0.36,3.59-1.09,5.11-2.11l-0.2-3.95l3.95,0.2c1.02-1.52,1.75-3.25,2.11-5.11l-2.93-2.65l2.93-2.65 C260.23,70.39,259.51,68.66,258.48,67.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M253.05,74.9c0,3.35-2.72,6.07-6.07,6.07s-6.07-2.72-6.07-6.07c0-3.35,2.72-6.07,6.07-6.07 S253.05,71.54,253.05,74.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M397.85,330.59l-3.95,0.2l0.2-3.95c-1.52-1.02-3.25-1.75-5.11-2.11l-2.65,2.93l-2.65-2.93 c-1.86,0.36-3.59,1.09-5.11,2.11l0.2,3.95l-3.95-0.2c-1.02,1.52-1.75,3.25-2.11,5.11l2.93,2.65l-2.93,2.65 c0.36,1.86,1.09,3.59,2.11,5.11l3.95-0.2l-0.2,3.95c1.52,1.02,3.25,1.75,5.11,2.11l2.65-2.93l2.65,2.93 c1.86-0.36,3.59-1.09,5.11-2.11l-0.2-3.95l3.95,0.2c1.02-1.52,1.75-3.25,2.11-5.11l-2.93-2.65l2.93-2.65 C399.6,333.83,398.87,332.1,397.85,330.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M392.41,338.34c0,3.35-2.72,6.07-6.07,6.07c-3.35,0-6.07-2.72-6.07-6.07c0-3.35,2.72-6.07,6.07-6.07 C389.69,332.27,392.41,334.99,392.41,338.34z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M45.13,296.37c-0.25-1.29-0.75-2.49-1.46-3.55l-2.74,0.14l0.14-2.74c-1.05-0.71-2.25-1.21-3.55-1.46 l-1.84,2.04l-1.84-2.04c-1.29,0.25-2.49,0.75-3.55,1.46l0.14,2.74l-2.74-0.14c-0.71,1.05-1.21,2.25-1.46,3.55l2.04,1.84 l-2.04,1.84c0.25,1.29,0.75,2.49,1.46,3.55l2.74-0.14l-0.14,2.74c1.05,0.71,2.25,1.21,3.55,1.46l1.84-2.04l1.84,2.04 c1.29-0.25,2.49-0.75,3.55-1.46l-0.14-2.74l2.74,0.14c0.71-1.05,1.21-2.25,1.46-3.55l-2.04-1.84L45.13,296.37z M35.68,302.42 c-2.33,0-4.21-1.89-4.21-4.21c0-2.33,1.89-4.21,4.21-4.21c2.33,0,4.21,1.89,4.21,4.21C39.9,300.54,38.01,302.42,35.68,302.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M444.07,66.99c-0.25-1.29-0.75-2.49-1.46-3.55l-2.74,0.14l0.14-2.74c-1.05-0.71-2.25-1.21-3.55-1.46 l-1.84,2.04l-1.84-2.04c-1.29,0.25-2.49,0.75-3.55,1.46l0.14,2.74l-2.74-0.14c-0.71,1.05-1.21,2.25-1.46,3.55l2.04,1.84 l-2.04,1.84c0.25,1.29,0.75,2.49,1.46,3.55l2.74-0.14l-0.14,2.74c1.05,0.71,2.25,1.21,3.55,1.46l1.84-2.04l1.84,2.04 c1.29-0.25,2.49-0.75,3.55-1.46l-0.14-2.74l2.74,0.14c0.71-1.05,1.21-2.25,1.46-3.55l-2.04-1.84L444.07,66.99z M434.62,73.04 c-2.33,0-4.21-1.89-4.21-4.21c0-2.33,1.89-4.21,4.21-4.21s4.21,1.89,4.21,4.21C438.83,71.15,436.94,73.04,434.62,73.04z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomApPevelopment);
export default __webpack_public_path__ + "static/media/customAPPevelopment​.402512a74ab5240b142206415097e570.svg";
export { ForwardRef as ReactComponent };